import React, { useState, useEffect } from "react";
import "./AdminProjects.css";
import bfLogo from "../assets/bf_logo.png";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";

/* ===== FIREBASE ===== */
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

export default function AdminDocuments() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [currentUser, setCurrentUser] = useState(null);

  // STEBIME PRISIJUNGIMĄ (Kad vadybininkas nebūtų išmestas ir sistema jį atpažintų)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      } else {
        navigate("/admin/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  return (
    <div className="projects-container">
      {/* PATAISYMAS: Pridėtas stilius, kad mygtukas būtų 30px nuo viršaus ir kairės */}
      <button 
        className="back-btn" 
        onClick={() => navigate("/admin")}
        style={{ position: "absolute", top: "30px", left: "30px", zIndex: 100 }}
      >
        ← {t('back')}
      </button>

      <div className="projects-content">
        <img src={bfLogo} alt="BF" className="projects-logo" />
        <h1 className="projects-title">{t('documents')}</h1>

        <div className="projects-list">
          
          {/* ĮMONĖS DOKUMENTŲ KORTELĖ */}
          <div
            className="project-card"
            style={{
              cursor: "pointer",
              border: "1px solid #38bdf8", 
              boxShadow: "0 0 15px rgba(56, 189, 248, 0.15)"
            }}
            onClick={() => navigate("/admin/documents/company")}
          >
            <div className="project-name" style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                <FileText size={24} color="#38bdf8"/>
                {t('company_documents')}
            </div>
            <div className="project-meta">
              {t('company_docs_desc')}
            </div>
            <div style={{marginTop: '10px', fontSize: '12px', color: '#38bdf8', fontWeight: 'bold'}}>
                {t('open')} →
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}